import React from 'react'
import { useConfiguratorContext } from '@augmatica/iframe-interface-react'

import InfoButton from '../InfoButton/InfoButton'
import Select from '../Select/Select'

import * as Styled from '../styles'
import { useAppSelector } from '../../hooks'

const ASSEMBLY_ID = 'assembly'

const formatValue = (value: string | number): string => value.toString().toString().replace('.', ',')

// TODO--låg-prio slå ihop komponenter
const SnowZonePanel: React.FC = () => {
  const configurator = useConfiguratorContext()

  const {
    props: { snowZone },
  } = useAppSelector((state) => state.configResult) as any
  const { content } = useAppSelector((state) => state.init)

  const availableOptions = snowZone.options.filter((option: any) => option.available)

  return (
    <Styled.Panel>
      {availableOptions.length === 1 ? (
        <>
          <span>
            {content?.props?.snowZone?.title}: <strong>{formatValue(availableOptions[0].value)}</strong>
            <InfoButton dangerouslySetInfo={content?.props?.snowZone?.['description_WHEN_roofKind:gable']} />
          </span>
          <span>
            {content?.props?.snowZone?.['description_2_WHEN_roofKind:gable']}
            <br />
            <em>{content?.props?.snowZone?.description_3}</em>
          </span>
        </>
      ) : (
        <>
          <Select
            id="snowZone"
            value={snowZone.value}
            onChange={(event: any) => {
              configurator.updateItem(ASSEMBLY_ID, ASSEMBLY_ID, {
                snowZone: +event.target.value,
              })
            }}
            options={snowZone.options.flatMap((option: any) =>
              option.available ? [{ key: option.value, value: option.value, disabled: false }] : []
            )}
            formatterForOption={formatValue}
            label={content?.props?.snowZone?.title}
            dangerouslySetInfo={content?.props?.snowZone?.['description_WHEN_roofKind:pent']}
          />
          <span>
            {content?.props?.snowZone?.['description_2_WHEN_roofKind:pent']}
            <br />
            <em>{content?.props?.snowZone?.description_3}</em>
          </span>
        </>
      )}
    </Styled.Panel>
  )
}

export default SnowZonePanel
